import { ValueType } from 'recharts/types/component/DefaultTooltipContent'
import { UnitType, UnitTypes } from 'src/Libs/types'

export const formatYTicks = (value: ValueType, unit: UnitType): string => {
  if (unit === UnitTypes.centsPerKiloWattHour || unit === UnitTypes.watt) {
    const formattedValue = Number(value).toFixed(0)
    return `${formattedValue} ${unit}`
  }
  return `${value} ${unit}`
}
